import React from 'react';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  const lastUpdated = "2025, December 18";

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <h1 className="privacy-title">Privacy Policy</h1>
          <div className="last-updated">
            Last updated: <strong>{lastUpdated}</strong>
          </div>
          <p className="privacy-intro">
            Your privacy is important to us. This Privacy Policy explains how CBC Center collects, 
            uses, and protects your personal information when you use our educational platform.
          </p>
        </div>

        <div className="privacy-content">
          <section className="policy-section">
            <h2 className="section-title">1. Information We Collect</h2>
            <p>We collect the following types of information:</p>
            <ul>
              <li><strong>Personal Information:</strong> When you contact us, we may collect your name and email address.</li>
              <li><strong>Usage Data:</strong> We collect anonymous usage statistics to improve our services.</li>
              <li><strong>Technical Data:</strong> Information about your device, browser, and IP address for security purposes.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2 className="section-title">2. How We Use Your Information</h2>
            <p>We use the information we collect for the following purposes:</p>
            <ul>
              <li>To provide and maintain our educational services</li>
              <li>To respond to your inquiries and provide support</li>
              <li>To improve and optimize our platform</li>
              <li>To analyze usage patterns and enhance user experience</li>
              <li>To ensure the security and integrity of our platform</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2 className="section-title">3. Data Protection</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your 
              personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>
            <div className="protection-points">
              <div className="protection-item">
                <span className="protection-icon">🔒</span>
                <div>
                  <h4>Encryption</h4>
                  <p>All data transmissions are encrypted using SSL/TLS technology</p>
                </div>
              </div>
              <div className="protection-item">
                <span className="protection-icon">🛡️</span>
                <div>
                  <h4>Access Control</h4>
                  <p>Strict access controls limit who can view personal information</p>
                </div>
              </div>
              <div className="protection-item">
                <span className="protection-icon">📊</span>
                <div>
                  <h4>Data Minimization</h4>
                  <p>We only collect data necessary for providing our services</p>
                </div>
              </div>
            </div>
          </section>

          <section className="policy-section">
            <h2 className="section-title">4. Third-Party Services</h2>
            <p>
              We use trusted third-party services to help operate our platform. These include:
            </p>
            <ul>
              <li><strong>Analytics Services:</strong> To understand how users interact with our platform</li>
              <li><strong>Hosting Providers:</strong> To store and serve our content securely</li>
              <li><strong>Email Services:</strong> To communicate with users when necessary</li>
            </ul>
            <p>
              All third-party providers are required to maintain the confidentiality and security 
              of your information.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of communications from us</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at{' '}
              <a href="mailto:privacy@cbccenter.co.ke">privacy@cbccenter.co.ke</a>
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">6. Children's Privacy</h2>
            <p>
              Our platform is designed for educational use by students of all ages. We do not 
              knowingly collect personal information from children under 13 without parental consent.
            </p>
            <p>
              If you are a parent or guardian and believe your child has provided us with personal 
              information, please contact us immediately.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">7. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify users of any 
              significant changes by posting the new Privacy Policy on this page and updating 
              the "Last updated" date.
            </p>
            <p>
              Your continued use of CBC Center after any changes constitutes your acceptance 
              of the updated Privacy Policy.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;